// True on any NON-production host — localhost, Vercel preview URLs, and
// any staging/test domain. Production is the live site, where dev-only
// affordances (e.g. the Otto gallery) must never appear.
//
// Override for a one-off check: localStorage 'otto_gallery' = '1' forces
// it on (even on prod), '0' forces it off.
const PROD_HOSTS = [
  'supplypilot.alchemy-byfusion.com',
  'www.supplypilot.alchemy-byfusion.com',
];

export function isTestEnv() {
  if (typeof window === 'undefined') return false;
  try {
    const forced = window.localStorage.getItem('otto_gallery');
    if (forced === '1') return true;
    if (forced === '0') return false;
  } catch (e) { /* ignore */ }
  return !PROD_HOSTS.includes(window.location.hostname);
}
